import axios from "axios";
import { ADMIN_PORTAL_API_BASE_URL, ADMIN_PORTAL_AUTH_TOKEN } from "../utils/config";


export const getDocs = async (activeTab) => {
    let config = {
        method: "get",
        url: activeTab === "ABCD App" ? `${ADMIN_PORTAL_API_BASE_URL}/list_documents` : `${ADMIN_PORTAL_API_BASE_URL}/list_documents_service`,
        headers: {
            Authorization: "Bearer" + ADMIN_PORTAL_AUTH_TOKEN
        }
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

